module.exports = __webpack_public_path__ + "assets/img/send-mail.06443697.svg";